<template>
	<LayoutTableCommonRow>
		<LayoutTableCommonPartText :text="sale.customer.name" :header="dateDiff" :subtext="(sale.users.length > 0) ? `Asignada a ${userList}` : ((sale.customer?.active_user) ? `Asignar a ${sale.customer.active_user.name}` : 'Sin vendedor activo')" :colspan="(sale.user?.pivot.transaction) ? 1 : 2">
			<template #extras>
				<span class="text-sm font-code">{{ vueNumberFormat(sale.amount, { suffix: ` ${sale.currency}`, precision: 2 }) }}</span>
			</template>
		</LayoutTableCommonPartText>
		<LayoutTableCommonPartRaw class="font-code lh-xs align-center text-end" v-if="sale.user?.pivot.transaction">
			<div class="text-muted text-lg d-inline" v-tooltip:left="`<b>Comisión:</b><br />${sale.user?.pivot.transaction.amount} ${sale.currency}`"><i class="bi bi-coin"></i></div>
		</LayoutTableCommonPartRaw>
		<LayoutTableCommonPartInfo :info="extras" />
		<LayoutTableCommonPartRaw class="font-code lh-xs align-center text-end" width="10%">
			<button type="button" class="btn btn-xs btn-danger rounded-pill" :disabled="submitting" @click="unassign" v-if="sale.users.length > 0">Desasignar</button>
			<button type="button" class="btn btn-xs btn-success rounded-pill" :disabled="submitting" @click="assign" v-else-if="sale.customer?.active_user">Asignar</button>
		</LayoutTableCommonPartRaw>
	</LayoutTableCommonRow>
</template>

<script>
	import { computed, getCurrentInstance, inject } from 'vue';
	import moment from 'moment';
	import _ from 'lodash';

	export default {
		emits: ['assign', 'unassign'],
		props: {
			sale: Object,
			submitting: Boolean
		},
		setup(props, { emit }) {
			const instance = getCurrentInstance();
			const $env = inject('$env');
			const dateDiff = computed(() => moment(props.sale.created_at).fromNow());
			const dateFormatted = computed(() => moment(props.sale.created_at).format('LL'));
			const userList = computed(() => _.join(_.map(props.sale.users, 'name'), ', '));
			const assign = () => emit('assign', props.sale);
			const unassign = () => emit('unassign', props.sale);

			const extras = computed(() => {
				let data = [];

				if(props.sale?.customer?.active_user?.pivot?.status) {
					data.push(`<b>Estado actual:</b> ${(props.sale.customer.active_user.pivot.status in $env.MODEL.CustomerUser.statuses) ? $env.MODEL.CustomerUser.statuses[props.sale.customer.active_user.pivot.status].title : 'Sin identificar'}`);
				}

				if((props.sale?.customer?.histories_count ?? 0) > 0) {
					data.push(`<b>Estados registrados:</b> ${props.sale?.customer?.histories_count}`);
				}else{
					data.push(`<b>Sin cambios de estados</b>`);
				}

				if((props.sale?.customer?.proposals_count ?? 0) > 0) {
					data.push(`<b>Propuestas enviadas:</b> ${props.sale?.customer?.proposals_count}`);
				}else{
					data.push(`<b>Sin propuestas enviadas</b>`);
				}

				if(data.length == 0) {
					data.push('Sin información adicional');
				}

				return data.join('<br />');
			});

			return { dateDiff, dateFormatted, userList, assign, unassign, extras };
		}
	}
</script>